import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import AuthWrapper from '../../components/AuthWrapper';
import AuthTop from '../../components/AuthTop';
import AuthBottom from '../../components/AuthBottom';
import './AuthPage.css';
import { SIGN_UP_URL } from '../../utils/constants';

function AuthPage({ location }) {
  return (
    <div className="expand-wrap">
      <Helmet>
        <title>Home Page</title>
      </Helmet>
      <AuthWrapper>
        <AuthTop>
          <div className="auth-top">
            <label>Don&apos;t have an online account yet?</label>
            <a href={SIGN_UP_URL} className="btn btn-info btn-block btn-square">
              <span>Sign Up</span>
            </a>
          </div>
        </AuthTop>
        <AuthBottom>
          <div className="auth-bottom">
            <label>Already a member?</label>
            <Link to="/login" className="btn btn-success btn-block btn-square">
              <span>Sign in</span>
            </Link>
          </div>
        </AuthBottom>
      </AuthWrapper>
    </div>
  );
}

export default AuthPage;



// WEBPACK FOOTER //
// ./src/containers/AuthPage/index.js